// extracted by mini-css-extract-plugin
export default {"cabinet":"cabinet_cabinet__QAHZZ","cabinet_wrapp":"cabinet_cabinet_wrapp__e24CQ","btn_exit":"cabinet_btn_exit__FwBbK"};